var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from 'shared/components';
import { useUndoTimerContext } from '../contexts';
export var UndoTimer = function () {
    var secondsUntilExpiration = useUndoTimerContext().secondsUntilExpiration;
    var warning = secondsUntilExpiration <= 60 * 5;
    var minutesRemaining = Math.floor(secondsUntilExpiration / 60);
    var secondsOutsideMinutes = secondsUntilExpiration % 60;
    var secondsCopy = "".concat(secondsOutsideMinutes, " second").concat(secondsOutsideMinutes !== 1 ? 's' : '');
    var minutesCopy = "".concat(minutesRemaining, " minute").concat(minutesRemaining !== 1 ? 's' : '');
    var timerCopy = minutesRemaining > 0 ? "".concat(minutesCopy, " ").concat(secondsCopy) : secondsCopy;
    return (_jsxs(Text, __assign({ pb: 2, size: "body2" }, { children: ["You have", ' ', _jsx(Text, __assign({ as: "span", color: warning ? 'red.500' : 'inherit', size: "body2" }, { children: timerCopy })), ' ', "to undo this note before it is locked."] })));
};
